import { BUTTON_COLORS, BUTTON_VARIANTS } from "components/shared/Button/Button";
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { AxiosError } from "axios";
import { useValidate } from "hooks/useValidate";
import ModalPortal from "components-new/ModalPortal";
import sass from "pages/References/BusinessProcessRegistry/ItemBuisnesTemplate/register.module.sass";
import InputTemp from "components-new/InputTemp";
import TextArea from "components-new/Textarea";
import GroupCheck from "components-new/GroupCheck";
import { Button } from "components/shared";
import { IBusinessProcessAdded } from "pages/References/BusinessProcessRegistry/ItemBuisnesTemplate/ItemBuisnesTemplate";
import { organizationAPI } from "libs/apiClient/Organization";
import { directoryAPI } from "libs/apiClient/Directory";
import { snackWrapper } from "helpers";

export const ConfirmArchiveTemplate: React.FC<{ cancelWindow: () => void; ok: () => void }> = ({
	ok,
	cancelWindow,
}) => {
	return (
		<ModalPortal className={sass.modalWrapperSm} outSide={false} title={"Вы уверены?"} handleClose={cancelWindow}>
			<div className={sass.modal}>
				<span className={sass.confirm}>
					В архив переместится шаблон и <span style={{ fontWeight: 700 }}>всё его содержимое</span>
				</span>
				<div className={sass.btns}>
					<Button onClick={cancelWindow} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button color={BUTTON_COLORS.ERROR} onClick={ok}>
						Архивировать
					</Button>
				</div>
			</div>
		</ModalPortal>
	);
};
export const ConfirmRemoveRow: React.FC<{ cancelWindow: () => void; remove: () => void }> = ({
	remove,
	cancelWindow,
}) => {
	return (
		<ModalPortal className={sass.modalWrapperSm} outSide={false} title={"Удалить строку"} handleClose={cancelWindow}>
			<div className={sass.modal}>
				<div className={sass.btns}>
					<Button onClick={cancelWindow} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button color={BUTTON_COLORS.ERROR} onClick={remove}>
						Удалить
					</Button>
				</div>
			</div>
		</ModalPortal>
	);
};

const initial: IBusinessProcessAdded = {
	name: "",
	clazz: NaN,
	consequenceDescr: "sad",
	criticality: false,
	defense: false,
	ecologic: false,
	economic: false,
	politic: false,
	reason: "",
	social: false,
	sequenceNumber: "",
	shortDescription: "",
};
const errorsRequest = {
	name: "Статус уже существует",
};
const initialErrorsRequest = {
	name: "",
};
export const Modal: React.FC<{
	rootFunc: () => void;
	trigger: { active: boolean; data: IBusinessProcessAdded | null; loadTemplate?: boolean };
	cancelWindow: () => void;
}> = ({ trigger, rootFunc, cancelWindow }) => {
	const [newType, setNewType] = useState<IBusinessProcessAdded>(initial);

	const [classOptions, setClassOptions] = useState<{ bpCount: number; id: number; name: string }[]>([]);
	const params = useParams();

	const updateData = async () => {
		const response = await organizationAPI.processesPatternsAllList();
		if (response && params.templateId) {
			const currentTemplate = response.data.find((_) => _.patternId === Number(params.templateId));
			if (currentTemplate) {
				return currentTemplate;
			}
		}
		return null;
	};

	useEffect(() => {
		if (trigger.data) {
			setNewType(trigger.data);
		} else {
			setNewType(initial);
		}
		directoryAPI.bpClassesList().then((r) => {
			setClassOptions(r.data);
		});
		//eslint-disable-next-line
	}, [trigger.active]);
	const [errors, setErrors] = useState(initialErrorsRequest);

	const setError = (arr: Array<keyof typeof errors>) => {
		setErrors(() => {
			let newData: typeof errors = {
				name: "",
			};
			arr.forEach((_) => {
				newData[_] = errorsRequest[_];
			});
			return newData;
		});
	};
	const send = async () => {
		const { patternId, ...data } = newType;
		if (!trigger.data) {
			const currentTemplate = await updateData();
			if (currentTemplate)
				organizationAPI
					.processesPatternCreateBpItemCreate(currentTemplate.patternId, {
						...data,
					})
					.then(() => {
						snackWrapper("success", "Запись успешно создана");
						rootFunc();
						cancelWindow();
					})
					.catch((e: AxiosError) => {
						if (e.response && e.response.status === 409 && e.response.data) {
							setError(Array.isArray(e.response.data) ? e.response.data : (e.response.data as string).split(" "));
						}
					});
		} else {
			if (patternId)
				organizationAPI
					.processesPatternItemEditCreate(patternId, { ...data })
					.then(() => {
						snackWrapper("success", "Запись успешно отредактирована");
						rootFunc();
						cancelWindow();
					})
					.catch((e: AxiosError) => {
						if (e.response && e.response.status === 409 && e.response.data) {
							setError(Array.isArray(e.response.data) ? e.response.data : (e.response.data as string).split(" "));
						}
					});
		}
	};

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { validate } = useValidate(newType, ["name"], send);

	const changeField = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		let { name, value } = e.target;
		if (/^\s/.test(value)) value = value.replace(/^\s/, "");
		setErrors((prevState) => ({ ...prevState, [name]: "" }));
		setNewType((prevState) => ({ ...prevState, [name]: value }));
	};
	useEffect(() => {
		return () => setErrors(initialErrorsRequest);
	}, [trigger.active]);

	// const [file,setFile] = useState<File>()

	// const selectFile = (e:React.ChangeEvent<HTMLInputElement>) => {
	//     if (e.target.files&&e.target.files.length) {
	//         const file = new FormData();
	//         file.append('file',e.target.files[0])
	//         setFile(e.target.files[0])
	//         // send(file)
	//         // setFile(file)
	//         // setModal(true)
	//     }else{
	//         // close()
	//     }
	// };

	const disabled = useMemo(() => {
		const check = [newType.defense, newType.social, newType.politic, newType.economic, newType.ecologic].every((_) => {
			return !_;
		});
		return (
			!newType.clazz ||
			// !newType.consequenceDescr||
			!newType.reason ||
			!newType.shortDescription ||
			check
		);
	}, [newType]);

	return trigger.active ? (
		<ModalPortal
			outSide={false}
			className={sass.modalWrapperMd}
			title={trigger.data ? "Редактирование бизнес-процесса" : "Создание бизнес-процесса"}
			handleClose={cancelWindow}>
			<div className={sass.modal}>
				<InputTemp
					type={"select"}
					name={"clazz"}
					value={newType.clazz ? classOptions.find((_) => _.id === newType.clazz)?.name || "" : ""}
					field={"name"}
					options={classOptions}
					onSelect={(e) => {
						setNewType((prevState) => ({ ...prevState, clazz: e.id }));
					}}
					placeholder={"Не выбрано"}
					label={"Класс бизнес-процесса"}
					required
				/>
				<InputTemp
					placeholder={"Введите текст"}
					name={"name"}
					value={newType.name}
					onChange={changeField}
					label={"Бизнес-процессы в деятельности организации"}
					required
				/>
				{/*<TextArea rows={2} value={newType.consequenceDescr} name={'consequenceDescr'} onChange={changeField}*/}
				{/*          placeholder={'Введите текст'} label={'Описание возможных последствий'}/>*/}
				<TextArea
					rows={6}
					value={newType.shortDescription}
					name={"shortDescription"}
					onChange={changeField}
					placeholder={"Введите текст"}
					label={"Краткое описание бизнес-процессов в деятельности организации"}
					required
				/>
				<GroupCheck.Wrapper label={"Критерии значимости"} required>
					<GroupCheck.Item
						checked={newType.social}
						name={"social"}
						onChange={({ target }) =>
							setNewType((prevState) => ({
								...prevState,
								[target.name]: !prevState[target.name as keyof typeof prevState],
							}))
						}
						label={"Социальная"}
						type={"checkbox"}
					/>
					<GroupCheck.Item
						checked={newType.politic}
						name={"politic"}
						onChange={({ target }) =>
							setNewType((prevState) => ({
								...prevState,
								[target.name]: !prevState[target.name as keyof typeof prevState],
							}))
						}
						label={"Политическая"}
						type={"checkbox"}
					/>
					<GroupCheck.Item
						checked={newType.economic}
						name={"economic"}
						onChange={({ target }) =>
							setNewType((prevState) => ({
								...prevState,
								[target.name]: !prevState[target.name as keyof typeof prevState],
							}))
						}
						label={"Экономическая"}
						type={"checkbox"}
					/>
					<GroupCheck.Item
						checked={newType.ecologic}
						name={"ecologic"}
						onChange={({ target }) =>
							setNewType((prevState) => ({
								...prevState,
								[target.name]: !prevState[target.name as keyof typeof prevState],
							}))
						}
						label={"Экологическая"}
						type={"checkbox"}
					/>
					<GroupCheck.Item
						checked={newType.defense}
						name={"defense"}
						onChange={({ target }) =>
							setNewType((prevState) => ({
								...prevState,
								[target.name]: !prevState[target.name as keyof typeof prevState],
							}))
						}
						label={"Оборонная"}
						type={"checkbox"}
					/>
				</GroupCheck.Wrapper>
				<TextArea
					rows={2}
					value={newType.reason}
					name={"reason"}
					onChange={changeField}
					placeholder={"Введите текст"}
					label={"Описание возможных последствий"}
					required
				/>
				<GroupCheck.Wrapper label={"Заключение о критичности"} required>
					<GroupCheck.Item
						name={"criticality"}
						checked={newType.criticality}
						onChange={() => {
							setNewType((prevState) => ({ ...prevState, criticality: true }));
						}}
						label={"Критический"}
						type={"radio"}
					/>
					<GroupCheck.Item
						name={"criticality"}
						checked={!newType.criticality}
						onChange={() => {
							setNewType((prevState) => ({ ...prevState, criticality: false }));
						}}
						label={"Некритический"}
						type={"radio"}
					/>
				</GroupCheck.Wrapper>
				<div className={sass.btns}>
					<Button onClick={cancelWindow} variant={BUTTON_VARIANTS.OUTLINED}>
						Отменить
					</Button>
					<Button disabled={disabled} onClick={validate}>
						Готово
					</Button>
				</div>
			</div>
		</ModalPortal>
	) : null;
};
